var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.connected)?_c('div',{staticClass:"holidays"},[_c('h1',[_vm._v("Saisie des jours feriés")]),_c('HolidaysC')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }